import { render, staticRenderFns } from "./sdkInfo.vue?vue&type=template&id=58280748&scoped=true&"
import script from "./sdkInfo.vue?vue&type=script&lang=js&"
export * from "./sdkInfo.vue?vue&type=script&lang=js&"
import style0 from "./sdkInfo.vue?vue&type=style&index=0&id=58280748&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58280748",
  null
  
)

export default component.exports